<template>
    <div class="homeHeader xy-center" :class="{ showHeader: backColor }">
        <div class="container xy-between">
            <div class="left jf">
                <img
                    v-if="logo"
                    :src="logo"
                    alt="logo"
                />
                <img v-else src="../assets/img/headerLogo.png" alt=""/>
                <div class="jf c-fff">
                    <div class="font-size22 text">
                        {{ orgName }}
                    </div>
                    <div class="dote"></div>
                    <div class="font-size22 text">
                        {{ platformName }}
                    </div>
                </div>
            </div>
            <div class="right">
                <ul class="ulDeltDote font-size16">
                    <!--                    <li @click="goHome" class="yx-between shouye" v-if="navMenu">-->
                    <!--                        <div>首页</div>-->
                    <!--                        <div class="line"></div>-->
                    <!--                    </li>-->
                    <li v-for="item in navMenu"
                        :key="item.Id"
                        :class="$route.path === item.Path ? ['yx-between', 'shouye'] : undefined"
                        @click.stop="navigateByPath(item)">{{ item.Name }}
                        <div class="line" v-if="$route.path === item.Path"></div>
                    </li>
                    <li @click.stop="handleKetangClick">健康医卫云课堂</li>
                </ul>
                <div class="xy-start userInfoBox">
                    <div v-if="!isShowUserName" class="userInfo jf">
                        <!-- <div class="avtor"></div> -->
                        <div class="loginText font-size14" @click="loginBtn">
                            <span>登录</span>
                            <span>&nbsp;|&nbsp;</span>
                            <span>注册</span>
                        </div>
                    </div>
                    <div v-else class="userInfo jf userInfoHaveLogin">
                        <div class="avtor">
                            <img src="../assets/img/defaulteActor.png" alt=""/>
                        </div>
                        <div class="loginText font-size16">
                            <div class="UserName one-wrap font-size14">
                                {{ isPhoneNumber(userInfo.UserName) }}
                                <i class="el-icon-caret-bottom"></i>
                            </div>
                        </div>

                        <div class="toPersonCenter">
                            <div class="font-size14 centerTextBtn threedary
                                    jf
                                    cursor
                                "
                                 v-for="item in profileRoutes"
                                 :key="item.Code"
                                 @click.stop="routeToPath(item)">
                                <!--                                <i class="el-icon-user-solid c-32353A"></i>-->
                                {{ item.Name }}
                            </div>
                            <div class="
                                    logOutbtn
                                    font-size14
                                    threedary
                                    jf
                                    cursor"
                                 @click="loginOut">
                                <!--                                <i class="el-icon-s-unfold c-32353A"></i>-->
                                退出
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { loginOut } from "@/api/user";
import { codeMapModules } from "@/utils/platform-config"

export default {
    props: {
        state: {
            type: String,
            default: "",
        },
        backColor: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isShowHeader: true,
            userInfo: {},
            isShowUserName: false,
            navMenu: [], // 导航菜单
        };
    },
    computed: {
        profileRoutes() {
            const isManage = this.$store.state.userInfo?.isManage
            return isManage ? [{
                Name: "个人中心",
                Path: "/manage",
                Code: 4
            }] : this.$store.state.profileRoutes
        },
        orgName({ userInfo }) {
            return userInfo.OrganName || this.$store.state.groupInfo.Name || this.$store.state.groupInfo.GroupWebName || "朗润数据"
        },
        platformName({ userInfo }) {
            return userInfo.PlatformName || this.$store.state.groupInfo.PlatformName || "医学培训考试服务平台"
        },
        logo ({ userInfo }) {
            return userInfo.Logo || this.$store.state.groupInfo.GroupUserLogo
        }
    },
    watch: {
        "state.userInfo": {
            handler(val) {
                this.userInfo = this.$store.state.userInfo || {};
                if (this.userInfo && this.userInfo.userId) {
                    this.isShowUserName = true;
                } else {
                    this.isShowUserName = false;
                }
            },
            immediate: true,
            deep: true,
        },
    },
    created() {
        this.judgeIsLogin();
        this.getNavMenu();
        this.$bus.$on("pc-login-success", this.getNavMenu)
    },
    mounted() {
    },
    beforeDestroy() {
        this.$bus.$off("pc-login-success", this.getNavMenu)
    },
    methods: {
        async goOut() {
            try {
                const { data } = await loginOut();
                this.isShowUserName = false;
                this.$store.commit("setUser", null);
                this.$store.commit("setUserInfo", null);
                this.$store.commit("clearNavMenu");
                this.$store.commit("clearPersonCenter");
                window.location.href = window.location.pathname
            } catch (err) {
                console.log(err);
            }
        },
        judgeIsLogin() {
            let info = this.$store.state.userInfo;
            if (!info) {
                this.isShowUserName = false;
            } else {
                this.isShowUserName = true;
                this.userInfo = info;
            }
        },
        /**
         * 根据路径导航到不同页面
         * @param item: {
         * Id, Name 导航文字,
         * IsNeedLogin 导航到对应页面之前是否需要提前登录,
         * Path 路径 } item
         * @return {undefined}
         **/
        navigateByPath(item) {
            const {
                IsNeedLogin,
                Path
            } = item
            if (IsNeedLogin) {
                if (this.$store.getters.isLogin) {
                    this.$router.push(Path);
                } else {
                    this.$emit("openLoginDiolog");
                }
            } else {
                this.$router.push(Path);
            }
        },
        goHome() {
            this.$router.push("/");
        },
        loginBtn() {
            this.$emit("openLoginDiolog");
        },
        handleKetangClick () {
            window.open("https://zhiye.cqvip.com/course/jkyw", "__blank")
        },
        isPhoneNumber(tel) {
            var reg = /^0?1[3|4|5|6|7|8][0-9]\d{8}$/;
            if (reg.test(tel)) {
                tel = tel.substr(0, 3) + "****" + tel.substr(7);
                return tel;
            } else {
                return tel;
            }
        },
        goExam() {
            if (this.$store.getters.isLogin) {
                this.$router.push("/exam");
            } else {
                this.$emit("openLoginDiolog");
            }
        },
        loginOut() {
            this.$confirm(`是否确认退出${this.$store.state.userInfo.PlatformName}?`, "提示", {
                confirmButtonText: "确认退出",
                cancelButtonText: "我再想想",
                type: "warning",
            })
                .then(() => {
                    this.goOut();
                })
                .catch(() => {
                });
        },
        /**
         * 获取导航栏菜单
         * @return {Promise<unknown>}
         **/
        async getNavMenu() {
            let navMenu = this.$store.state.navMenu
            if (this.$store.getters.isLogin && this.$store.state.isLoadProfileRoutes === false) {
                await this.$store.dispatch("getPersonCenter")
            }
            if (this.$store.state.isLoadNavMenu === false) {
                navMenu = await this.$store.dispatch("getNavMenu")
            }
            this.navMenu = navMenu
        },
        routeToPath(item) {
            const isManage = this.$store.state.userInfo?.isManage
            if (codeMapModules[item.Code].enName === "profile-module" && isManage) {
                this.$router.push("/manage")
            } else {
                this.$router.push(item.Path)
            }
        }
    },
};
</script>

<style scoped lang="less">
.homeHeader {
    width: 100%;
    height: 70px;
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 200;
    background: linear-gradient(180deg, #61666d 0%, rgba(47, 49, 52, 0) 100%);

    .container {
        width: 62.5%;
        height: 100%;

        .left {
            img {
                width: 25px;
                margin-right: 10px;
            }

            .dote {
                background-color: white;
            }

            .text {
                font-size: 22px;
                font-weight: 600;
            }
        }

        .right {
            height: 100%;
            color: white;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            .ulDeltDote {
                padding: 0;
                display: flex;
                margin: 0 auto;
                align-items: center;
                width: 100%;

                li {
                    cursor: pointer;
                    text-align: center;
                    font-size: 16px;
                    margin-right: 20px;
                }

                .shouye {
                    color: #256cf4;

                    .line {
                        width: 20px;
                        height: 6px;
                        background: #256cf4;
                        border-radius: 3px;
                    }
                }
            }

            .userInfoBox {
                min-width: 100px;
                //   padding-top: 5px;
                //   box-sizing: border-box;
            }

            .userInfo {
                .avtor {
                    margin-right: 5px;
                    border-radius: 50%;
                    width: 30px;
                    height: 30px;
                    background: #efefef;
                    border: 1px solid #ffffff;

                    img {
                        width: 100%;
                    }
                }

                .loginText {
                    cursor: pointer;
                }

                .UserName {
                    max-width: 200px;
                }
            }

            .userInfoHaveLogin {
                position: relative;
                height: 69px;

                .toPersonCenter {
                    overflow: hidden;
                    display: none;
                    min-width: 130px;
                    background-color: white;
                    position: absolute;
                    top: 55px;
                    right: 0;
                    border-radius: 6px;
                    box-shadow: 0px 2px 40px 0px rgba(229, 232, 236, 0.8);

                    .centerTextBtn {
                        width: 100%;
                        height: 40px;
                        padding: 10px;
                        box-sizing: border-box;
                        border-bottom: 1px solid #f0f3f7;
                        display: block;
                        text-align: center;

                        i {
                            margin-right: 10px;
                        }
                    }

                    .centerTextBtn:hover {
                        background-color: #f0f3f7;
                    }

                    .logOutbtn {
                        width: 100%;
                        height: 40px;
                        padding: 10px;
                        box-sizing: border-box;
                        display: block;
                        text-align: center;

                        i {
                            margin-right: 10px;
                        }
                    }

                    .logOutbtn:hover {
                        background-color: #f0f3f7;
                    }
                }
            }

            .userInfoHaveLogin:hover .toPersonCenter {
                display: block;
            }
        }
    }
}

.showHeader {
    background: white;
    box-shadow: rgb(204, 204, 204) 1px 1px 11px;

    .container {
        .left {
            .dote {
                background-color: #2f3134;
            }

            .text {
                color: #2f3134;
            }
        }

        .right {
            .ulDeltDote {
                color: #2f3134;
            }

            .userInfoBox {
                color: #2f3134;
            }
        }
    }
}
</style>
